<div class="row">
  <div class="col-12 card">
    <div class="card-body text-center">
      <h2>404: Page Not Found</h2>
      <p>Oh gosh darn, there's nothing here :(</p>
      <a class="btn btn-danger" href="/">Get out of here!</a>
    </div>
  </div>
  </div>
